module.exports = __webpack_public_path__ + "assets/img/f40edc1a286b17db8499485a77a162d1.svg";